<template>
  <SysDialogFullscreen v-model="DIALOG_ATIVO" titulo="Estoques Disponíveis" transition="dialog-bottom-transition">
    <template #titulo-parte-direita>
      <div class="mr-3">
        <v-badge v-if="pedido_carrinho.total_itens > 0" color="white" overlap class="ml-n2">
          <template #badge>
            <span class="text-black">{{ pedido_carrinho.total_itens }}</span>
          </template>

          <v-btn color="#A51B32" small dark @click="$emit('abrir-carrinho-transferencia', {})">
            <v-icon :size="18" class="mr-1">mdi-truck</v-icon>
            Carrinho
          </v-btn>
        </v-badge>
      </div>
    </template>

    <div class="px-3 py-2 d-flex align-center text-gray-1000 font-15">
      <p class="ma-0 font-weight-medium">
        <span>{{ `Filial ${produto_filial_destino.filial}` }}</span>
        <span class="mx-3">/</span>
        <span>{{ `${produto_filial_destino.idfornecedor} - ${produto_filial_destino.razao_social}` }}</span>
        <span class="mx-3">/</span>
        <span>{{ `${produto_filial_destino.idproduto} - ${produto_filial_destino.descricao_produto}` }}</span>
      </p>

      <v-spacer />

      <span>
        Necessidade Restante:&nbsp;
        {{ Helpers.formatarValor(Math.max(produto_filial_destino.saldo_necessidade_drp - QTDE_NECESSIDADE_SATISFEITA, 0)) }}
      </span>
    </div>

    <sys-data-table
      :height="alturaDaJanela - 138"
      :item-height="45"
      :headers="CEBECALHOS_COMPUTED"
      :items="PRODUTOS_COMPUTED"
      class="pl-2"
      :item-class="classesCssItem"
    >
      <template #item.status_estoque="{item}">
        <Legenda v-if="configuracaoDRP.drp_pertence_mix === 'S' && !item.pertence_mix_filial" titulo="Status" legenda="Distribuição feita com todo o estoque, pois esse produto não faz pasrte do mix da filial">
          <v-icon color="orange">mdi-home-remove</v-icon>
        </Legenda>

        <Legenda v-else-if="item.status_estoque > 0" titulo="Status" legenda="Distribuição feita com estoque disponível">
          <v-icon color="green">mdi-check-all</v-icon>
        </Legenda>

        <Legenda v-else titulo="Status" legenda="Distribuição feita com estoque da filial em carater de urgência!">
          <v-icon color="red">mdi-alert</v-icon>
        </Legenda>
      </template>

      <template #item.filial="{item}">
        <div class="d-flex align-center">
          {{ item.filial }}

          <DetalhesProdutoDrp
            :idgrupo="produto_filial_destino.grupo"
            :filial_destino="produto_filial_destino.filial"
            :filial_origem="item.filial"
            :idproduto="produto_filial_destino.idproduto"
            status_abastecimento="DRP"
          />
        </div>
      </template>

      <template #item.pertence_mix_filial="{value}">{{ value ? 'SIM' : 'NÃO' }}</template>
      <template #item.filial_cd="{value}">{{ value === 'S' ? 'SIM' : 'NÃO' }}</template>
      <template #item.fator_conversao="{value}">{{ Helpers.formatarValor(value) }}</template>
      <template #item.consumo_medio_mensal="{value}">{{ Helpers.formatarValor(value) }}</template>
      <template #item.estoque="{value}">{{ Helpers.formatarValor(value) }}</template>
      <template #item.estoque_seguranca="{value}">{{ Helpers.formatarValor(value) }}</template>
      <template #item.ponto_pedido="{value}">{{ Helpers.formatarValor(value) }}</template>
      <template #item.estoque_maximo="{value}">{{ Helpers.formatarValor(value) }}</template>

      <template #item.estoque_drp="{item}">
        <span :class="{'text-red': Number(item.necessidade) > Number(item.estoque_drp)}">
          {{ Helpers.formatarValor(item.estoque_drp) }}
        </span>
      </template>

      <template #item.necessidade_drp_embalagem="{item}">
        {{ Helpers.formatarValor(item.necessidade / multiplo_dist_destino) }}
      </template>

      <template #item.necessidade="{item}">
        <div class="w-max-100">
          <SysInputFormatadorDeValor
            v-model="item.necessidade"
            :remover-valor-irrelevante="true"
            hide-details
            centralizar
            :max-digitos="4"
            class="input-regular"
            @focus="$event.target.select()"
            @keydown.enter="adicionarNoCarrinho(item)"
            @keydown="item.no_carrinho = false"
          />
        </div>
      </template>

      <template #item.acoes="{item}">
        <v-icon v-if="item.no_carrinho" :size="20" class="ml-2" color="green">mdi-truck-check</v-icon>

        <v-btn
          v-else
          :disabled="Number(item.necessidade) === 0 || Number(item.necessidade) > Number(item.estoque_drp)"
          icon
          @click="adicionarNoCarrinho(item)"
        >
          <v-icon center>mdi-forklift</v-icon>
        </v-btn>
      </template>

      <template #footer>
        <v-spacer />

        <v-switch v-model="ocultar_produto_carrinho" hide-details dense color="#a71830" class="mr-6">
          <template #label>
            <span class="ml-2 font-12">Ocultar produto que já estão no carrinho</span>
          </template>
        </v-switch>

        <div class="mr-6">
          <v-icon :size="20" class="mr-1" color="green">mdi-truck-check</v-icon>
          <span class="font-12">Produto está no carrinho</span>
        </div>

        <span class="font-12 text-gray-800 py-2 pr-3">Total de Itens: {{ Helpers.formatarValor(PRODUTOS_COMPUTED.length) }}</span>
      </template>
    </sys-data-table>
  </SysDialogFullscreen>
</template>

<script>
import SysDialogFullscreen from "../../../padraoDeLayout/SysDialogFullScreen.vue";
import ResponsiveHeight from "../../../../helpers/ResponsiveHeight";
import DrpAPI from "../../../../api/drp";
import {logout} from "../../../../helpers";
import Legenda from "../../../produto/detalhes/Legenda.vue";
import DetalhesProdutoDrp from "../DetalhesProduto/Index.vue";
import SysInputFormatadorDeValor from "../../../utils/InputFormatadorDeValor.vue";

export default {
  name: "FiliaisComEstoqueDisponivelParaTransferencia",
  mixins: [ResponsiveHeight],
  components: {
    SysInputFormatadorDeValor,
    DetalhesProdutoDrp,
    Legenda,
    SysDialogFullscreen
  },
  model: {
    'prop': 'modelValue',
    'event': 'update:modelValue',
  },
  props: {
    modelValue: Boolean,
    produto_filial_destino: Object,
    pedido_carrinho: Object,
    configuracaoDRP: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    cabecalhos: [
      { text: "Status", value: "status_estoque", align: "center" },
      { text: "Filial", value: "filial", align: "center" },
      { text: "Pertence ao Mix", value: "pertence_mix_filial", align: "center", style: {maxWidth: '100px'} },
      { text: "Filial CD", value: "filial_cd", align: "center" },
      { text: "UND Venda", value: "idunidade_medida", align: "center" },
      { text: "Fator", value: "fator_conversao" },
      { text: "Consumo", value: "consumo_medio_mensal" },
      { text: "Estoque Físico", value: "estoque" },
      { text: "Estoque Estético", value: "estoque_min", is_number: true },
      { text: "Eseg.", value: "estoque_seguranca" },
      { text: "PP.", value: "ponto_pedido" },
      { text: "EMax.", value: "estoque_maximo" },
      { text: "Estoque Disponível", value: "estoque_drp" },
      { text: "Necessidade DRP Embalagem", value: "necessidade_drp_embalagem" },
      { text: "Necessidade", value: "necessidade" },
      { text: "Ações", value: "acoes", align: "center" },
    ],
    itens: [],
    produtos_adicionado_carrinho: false,
    ocultar_produto_carrinho: false,
    multiplo_dist_destino: 1
  }),
  computed: {
    DIALOG_ATIVO: {
      get() {
        return this.modelValue
      },
      set(valor) {
        return this.$emit('update:modelValue', valor);
      }
    },
    QTDE_NECESSIDADE_SATISFEITA() {
      const callback = (a, b) => a + Number(b.necessidade || 0);
      return this.itens.reduce(callback, 0);
    },
    CEBECALHOS_COMPUTED() {
      if (this.configuracaoDRP.drp_pertence_mix === 'S') {
        return this.cabecalhos;
      }

      return this.cabecalhos.filter(item => item.value !== 'pertence_mix_filial')
    },
    PRODUTOS_COMPUTED() {
      if (!this.ocultar_produto_carrinho) {
        return this.itens;
      }

      return this.itens.filter(item => !item.no_carrinho);
    }
  },
  watch: {
    DIALOG_ATIVO() {
      if (this.DIALOG_ATIVO) {
        this.buscaFiliaisComEstoqueDisponivel();
      } else {
        this.itens = [];

        if (this.produtos_adicionado_carrinho) {
          this.$emit('update:produto-add-carrinho', {})
        }
      }
    }
  },
  methods: {
    classesCssItem(item) {
      return {
        'text-gray-100': item.no_carrinho,
      };
    },
    buscaFiliaisComEstoqueDisponivel() {
      const headers = this.Helpers.iniciarRequisicao();

      const {grupo, filial, idproduto: produto} = this.produto_filial_destino;
      const params = {grupo, filial, produto};


      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getProdutoDispDrp(headers, params)
          .then((response) => {
            const {token, drp: produtos, multiplo_dist_destino } = response.data;
            localStorage.token = token;

            let necessidade_restante = Number(this.produto_filial_destino.saldo_necessidade_drp);
            const callback = produto => {
              const necessidade = Math.min(necessidade_restante, Number(produto.estoque_drp));
              necessidade_restante -= necessidade;
              return {...produto, necessidade, no_carrinho: false};
            };
            this.multiplo_dist_destino = multiplo_dist_destino;
            this.itens = produtos.map(callback);
          })
          .catch(logout)
      );
    },
    adicionarNoCarrinho(produto) {
      if (Number(produto.necessidade) === 0 || Number(produto.necessidade) > Number(produto.estoque_drp)) {
        return;
      }

      const headers = this.Helpers.iniciarRequisicao();
      const iduser = localStorage.getItem("id");
      const params = {
        iduser: iduser,
        produto: produto.idproduto,
        filial_origem: produto.filial,
        filial_destino: this.produto_filial_destino.filial,
        qtde: produto.necessidade,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.addItemPedido(headers, params)
          .then(() => {
            produto.no_carrinho = true;
            this.produtos_adicionado_carrinho = true;
            this.pedido_carrinho.total_itens++;
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
